// extracted by mini-css-extract-plugin
export const outerWrapper = "jumbotron-module--outerWrapper--6aUaF";
export const wrapper = "jumbotron-module--wrapper--3tWaj";
export const intro = "jumbotron-module--intro--3qdaZ";
export const intro_title = "jumbotron-module--intro_title--np_pV";
export const intro_caption = "jumbotron-module--intro_caption--2gDEo";
export const meta = "jumbotron-module--meta--1O_xU";
export const meta_item = "jumbotron-module--meta_item--13I2c";
export const meta_icon = "jumbotron-module--meta_icon--2yJKO";
export const meta_text = "jumbotron-module--meta_text--2tKdu";